import DateTimePicker from "components/GenericComponent/DateTimePicker";
import NumberField from "components/GenericComponent/NumberField";
import NumberInput from "components/GenericComponent/NumberInput";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import React, { useState, useRef, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Controller, useForm } from "react-hook-form";
import { formatNumber } from "utils/currencyFormat";
import { convertToNumber } from "utils/numberExtension";
import { pushNotification } from "utils/notifications";
import useEscapeKey from "utils/useEscapeKey";
import TatToanChoDuyetApi from "../../../service/tatToanChoDuyetApi";
import { convertDate } from "utils/formatDate";
import CauHinhApi from "service/cauHinhApi";
import { currentDateV2 } from "utils/formatDate";

function DaoHo(props) {
  let { onHide, daoho, setDaoHo, postDaoHo, phikhac } = props;
  let { isShowFormDaoHo, daoHo, ConfigDaoHo } = daoho;
  const [isAction, setIsAction] = useState(false);
  const [HasTatToanChoDuyet, setHasTatToanChoDuyet] = useState(0);

  const daoHoRef = useRef(daoHo);
  daoHoRef.current = daoHo;
  console.log(daoho);
  let {
    TypePaid,
    CountTypePaid,
    BeforeAfter,
    Sotienvay,
    IsEditChoVay,
    LaiTraGop,
    NgayThanhToan,
    ValueLai,
    StatusPaidHo,
    TienCatTruoc,
    BocTrongVong,
    ValuePaid,
    Paided,
    TienDuaKhach,
  } = daoHo;
  let { objListPhiKhac } = phikhac;
  let currentForm = useForm({
    CountTypePaid: CountTypePaid,
    Sotienvay: Sotienvay,
    BocTrongVong: BocTrongVong,
    BeforeAfter: BeforeAfter,
    TypePaid,
    NgayThanhToan,
  });

  useEffect(() => {
    let isCurrentDaoHo = true;

    kiemTraHopDongChoVayTatToanChoDuyet();
    getTimeServer(() => isCurrentDaoHo);

    return () => {
      isCurrentDaoHo = false;
    };
  }, []);
  const kiemTraHopDongChoVayTatToanChoDuyet = () => {
    TatToanChoDuyetApi.kiemTraHopDongChoVayTatToanChoDuyet(daoHo.ChoVayId).then(
      (response) => {
        if (
          response.data != undefined &&
          response.data != null &&
          response.data.TatToanChoDuyet
        ) {
          setHasTatToanChoDuyet(response.data.TatToanChoDuyet);
        }
      }
    );
  };
  const getTimeServer = (isCurrentDaoHo) => {
    CauHinhApi.getTimeServer().then((response) => {
      if (response.status === 200 && isCurrentDaoHo()) {
        let dateTime = new Date(convertDate(response.data.result));
        setDaoHo({
          ...daoHoRef.current,
          NgayThanhToan: dateTime,
        });
      }
    });
  };
  const { register, handleSubmit, errors, control, setValue } = currentForm;
  const onChangeNgayThanhToan = (evt) => {
    daoHo.NgayThanhToan = evt;
    setDaoHo(daoHo);
    setIsAction(false);
  };
  const onChangeAttNumberChoVay = (field) => (evt) => {
    daoHo[field] = evt.target.value;
    setValue(field, evt.target.value);
    if (field === "Sotienvay") {
      daoHo.ValueHoaHong = (convertToNumber(evt.target.value) * 1.2) / 100;
      setValue("ValueHoaHong", daoHo.ValueHoaHong);
    }
    setDaoHo(daoHo);
    setIsAction(false);
  };
  const onChangeStatusPaidHo = () => (evt) => {
    daoHo.StatusPaidHo = parseInt(evt.target.value);
    setDaoHo(daoHo);
    setIsAction(false);
  };
  const onChangeTypePaid = () => (evt) => {
    if (evt.target.checked) {
      daoHo.TypePaid = 2;
    } else {
      daoHo.TypePaid = 1;
    }
    setDaoHo(daoHo);
    setIsAction(false);
  };
  const onChangeAttTextChoVay = (field) => (evt) => {
    daoHo[field] = evt.target.value;
    setValue(field, evt.target.value);
    setDaoHo(daoHo);
    setIsAction(false);
  };
  const onChangePhiKhac = (configId) => (evt) => {
    objListPhiKhac[configId].GiaTri = evt.value;
    setIsAction(false);
  };
  const onSubmit = (dataChoVay) => {
    if (LaiTraGop === 2) {
      if (
        Math.ceil(ValueLai * BocTrongVong) <
        Math.ceil(convertToNumber(Sotienvay))
      ) {
        pushNotification(
          "Tổng chi phí vay không được nhỏ hơn tiền cho vay",
          "error",
          "TOP_CENTER",
          2000
        );
        return;
      }
    }
    if (TienDuaKhach - (ValuePaid - daoHo.Paided) < 0) {
      pushNotification(
        "Số tiền khách nhận về phải lớn hơn 0",
        "error",
        "TOP_CENTER",
        2000
      );
      return;
    }
    setIsAction(true);
    dataChoVay.TypePaid = daoHo.TypePaid;
    dataChoVay.ChoVayId = daoHo.ChoVayId;
    dataChoVay.StatusPaidHo = daoHo.StatusPaidHo;
    dataChoVay.TienCatTruoc = ValuePaid - Paided - TienCatTruoc;
    postDaoHo({
      ChoVay: dataChoVay,
    });
    props.onRefes();
    // setTimeout(() => {
    //   setIsAction(false);
    // }, 3000);
  };
  const laiTraGopText = {
    1: "Lãi kỳ",
    2: "Tổng thu 1 kỳ",
    0: "Lãi tổng",
  };
  let { _allTraThieuTraDuTraGop, _allKyGopTraGop, _allBeforeAfterTraGop } =
    ConfigDaoHo;
  useEscapeKey(onHide);
  return (
    <Modal
      show={isShowFormDaoHo}
      size="modal-new-size modal-new-size"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Header>
          <h4 className="modal-title" id="myModalLabel16">
            <span className="btn-icon-right">
              <i className="mdi mdi-swap-horizontal"></i>
            </span>{" "}
            Đảo họ
          </h4>
          <button
            type="button"
            className="close-popup-new"
            data-dismiss="modal"
            aria-label="Close"
            onClick={onHide}
          >
            <i className="mdi mdi-close"></i>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="form tat-toan form-horizontal">
            <div className="form-body">
              {HasTatToanChoDuyet === 1 && (
                <>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="thongbaotattoan">
                        <i
                          class="mdi mdi-alert"
                          style={{ color: "#d39c00" }}
                        ></i>{" "}
                        HỢP ĐỒNG ĐANG CHỜ DUYỆT YÊU CẦU TẤT TOÁN
                      </div>
                    </div>
                  </div>
                </>
              )}
              <div className="card collapse-icon accordion-icon-rotate">
                <div
                  id="headingCollapse5678"
                  className="card-header border-info"
                  href="#collapse5678"
                  aria-expanded="true"
                  aria-controls="collapse5678"
                >
                  <a
                    className="card-title lead info collapsed"
                    href={() => false}
                  >
                    <h3>Thông tin đảo họ</h3>
                  </a>
                </div>
                <div
                  id="collapse5678"
                  aria-labelledby="headingCollapse5678"
                  className="card-collapse collapse show"
                  aria-expanded="true"
                >
                  <div className="card-content">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group row">
                            <div className="col-md-4">
                              <label className="label-control color7-bold">
                                Ngày đảo họ
                                <span className="canh-bao-red">*</span>
                              </label>
                              <br />
                              <DateTimePicker
                                onChange={onChangeNgayThanhToan}
                                value={NgayThanhToan}
                                customInputRef={register}
                                name="NgayThanhToan"
                                customInput={
                                  <input
                                    name="NgayThanhToan"
                                    ref={register}
                                  ></input>
                                }
                              ></DateTimePicker>
                            </div>
                          </div>
                          <div className="form-group row">
                            <div className="col-md-4">
                              <label className="label-control color7-bold">
                                Tổng tiền vay
                                <span className="canh-bao-red">*</span>
                              </label>
                              <br />
                              <NumberField
                                className="form-control input-sm"
                                name={"Sotienvay"}
                                value={Sotienvay}
                                inputRef={register({
                                  required: "Hãy nhập số tiền vay",
                                })}
                                onChange={onChangeAttNumberChoVay("Sotienvay")}
                              ></NumberField>
                              {errors.Sotienvay && (
                                <span className="canh-bao-red">
                                  {errors.Sotienvay.message}
                                </span>
                              )}
                            </div>
                            <div className="col-md-4">
                              <label className="label-control color7-bold">
                                Kiểu thu lãi
                                <span className="canh-bao-red">*</span>
                              </label>
                              <br />
                              <select
                                ref={register}
                                className="form-control input-sm"
                                onChange={onChangeStatusPaidHo()}
                                value={StatusPaidHo}
                                defaultValue={StatusPaidHo}
                                disabled={true}
                                name="StatusPaidHo"
                              >
                                <option value="1">Cắt lãi trước</option>
                                <option value="2">Thu lãi sau</option>
                              </select>
                            </div>
                          </div>
                          <div className="form-group row">
                            <div className="col-md-4">
                              <label className="label-control color7-bold">
                                {StatusPaidHo === 1
                                  ? "Tiền đưa khách"
                                  : laiTraGopText[LaiTraGop]}
                                <span className="canh-bao-red">*</span>
                              </label>
                              <br />
                              <NumberField
                                className="form-control input-sm"
                                name={"ValueLai"}
                                value={ValueLai}
                                inputRef={register({
                                  required: "Hãy nhập số",
                                })}
                                onChange={onChangeAttNumberChoVay("ValueLai")}
                              ></NumberField>
                              {errors.ValueLai && (
                                <span className="canh-bao-red">
                                  {errors.ValueLai.message}
                                </span>
                              )}
                            </div>
                            <div className="col-md-4">
                              {StatusPaidHo === 1 && (
                                <span>
                                  ( Cắt lãi trước:{" "}
                                  <span className="black-new">
                                    {formatNumber(TienCatTruoc)}
                                  </span>{" "}
                                  )
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="form-group row">
                            <div className="col-md-4">
                              <label className="label-control color7-bold">
                                Bốc trong vòng
                                <span className="canh-bao-red">*</span>
                                <PopoversBootrap
                                  contentText="Là tổng thời gian cho góp ví dụ cho góp 50 ngày thì nhập là 50"
                                  titleText=""
                                  trigger={["hover", "focus"]}
                                  placement={"top"}
                                >
                                  <i className="la la-question-circle tool-comment"></i>
                                </PopoversBootrap>
                              </label>
                              <br />

                              <fieldset>
                                <div className="input-group input-icon">
                                  <NumberField
                                    className="form-control input-sm"
                                    name={"BocTrongVong"}
                                    value={BocTrongVong}
                                    onChange={onChangeAttNumberChoVay(
                                      "BocTrongVong"
                                    )}
                                    inputRef={register}                          
                                  ></NumberField>
                                  <div className="input-group-append">
                                    <span
                                      className="input-group-text"
                                      id="basic-addon2"
                                    >
                                      {TypePaid === 1 ? "Ngày" : "Tháng"}
                                    </span>
                                  </div>
                                </div>
                              </fieldset>
                            </div>
                            {_allKyGopTraGop ? (
                              <div className="col-md-4 btn-checkbox-them-moi">
                                <label className="label-control color7-bold">
                                  <input
                                    type="checkbox"
                                    name="TypePaid"
                                    value={TypePaid}
                                    checked={TypePaid !== 1}
                                    onChange={onChangeTypePaid()}
                                  />{" "}
                                  <span className="check-box color7-bold ">
                                    Tính theo tháng{" "}
                                  </span>
                                </label>
                              </div>
                            ) : (
                              <input
                                type="hidden"
                                value={StatusPaidHo}
                                name="StatusPaidHo"
                                ref={register}
                              ></input>
                            )}
                          </div>
                          <div className="form-group row">
                            <div className="col-md-4">
                              <label className="label-control color7-bold">
                                Kỳ góp <span className="canh-bao-red">*</span>
                                <PopoversBootrap
                                  contentText="Ví dụ 10 ngày đóng tiền 1 lần thì nhập là 10"
                                  titleText=""
                                  trigger={["hover", "focus"]}
                                  placement={"top"}
                                >
                                  <i className="la la-question-circle tool-comment"></i>
                                </PopoversBootrap>
                              </label>
                              <fieldset>
                                <div className="input-group input-icon">
                                  <NumberField
                                    className="form-control input-sm"
                                    name={"CountTypePaid"}
                                    value={CountTypePaid}
                                    inputRef={register}
                                    onChange={onChangeAttNumberChoVay(
                                      "CountTypePaid"
                                    )}
                                  ></NumberField>
                                  <div className="input-group-append">
                                    <span
                                      className="input-group-text"
                                      id="basic-addon2"
                                    >
                                      {TypePaid === 1 ? "Ngày" : "Tháng"}
                                    </span>
                                  </div>
                                </div>
                              </fieldset>
                            </div>
                          </div>
                          <div className="form-group row">
                            {_allBeforeAfterTraGop ? (
                              <div className="col-md-4">
                                <label className="label-control color7-bold">
                                  Kiểu thanh toán{" "}
                                  <span className="canh-bao-red">*</span>
                                </label>

                                <select
                                  name="BeforeAfter"
                                  className="form-control input-sm"
                                  ref={register}
                                  value={BeforeAfter}
                                  onChange={onChangeAttTextChoVay(
                                    "BeforeAfter"
                                  )}
                                >
                                  <option value="1">Sau</option>
                                  <option value="2">Trước</option>
                                </select>
                              </div>
                            ) : (
                              <input
                                type="hidden"
                                name="BeforeAfter"
                                className="form-control input-sm"
                                ref={register}
                                value={BeforeAfter}
                              ></input>
                            )}
                          </div>

                          <div className="form-group row">
                            <div className="col-md-4">
                              {" "}
                              <label className="label-control color7-bold">
                                Tiền khách nhận về
                              </label>
                              <br />
                              {TienDuaKhach > 0 && (
                                <span className="red money-goc">
                                  {formatNumber(TienDuaKhach)} -{" "}
                                  {formatNumber(ValuePaid - Paided)} ={" "}
                                  {formatNumber(
                                    TienDuaKhach - (ValuePaid - Paided)
                                  )}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="form-group row">
                            {objListPhiKhac &&
                              objListPhiKhac.map((item, idx) => (
                                <div className="col-md-4">
                                  <div key={"phiKhac" + idx}>
                                    <NumberInput
                                      labelClass="col-md-2 label-control"
                                      inputClass="form-control input-sm"
                                      inputWrapClass="col-md-3"
                                      wrapperClass="form-group row"
                                      labelText={item.TenPhiKhac}
                                      inputProps={{
                                        name: "ListPhiKhac[" + idx + "].GiaTri",
                                        value: objListPhiKhac[idx].GiaTri,
                                        onChange: onChangePhiKhac(idx),
                                        control: control,
                                        // readOnly: IsEditChoVay,
                                      }}
                                    ></NumberInput>
                                    <input
                                      type="hidden"
                                      name={
                                        "ListPhiKhac[" +
                                        idx +
                                        "].ConfigPhiKhacId"
                                      }
                                      value={item.ConfigPhiKhacId}
                                      ref={register}
                                    />
                                  </div>
                                </div>
                              ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="modal-footer button-popup-new-size">
          {isAction == false && HasTatToanChoDuyet !== 1 && (
            <button type="submit" className="btn btn-new-main btn-checknew">
              <span className="btn-icon-left">
                <i className="mdi mdi-check"></i>
              </span>{" "}
              Xác nhận
            </button>
          )}
          <button
            className="btn btn-new-main btn-closenew"
            data-dismiss="modal"
            type="button"
            onClick={onHide}
          >
            <span className="btn-icon-left">
              <i className="mdi mdi-close"></i>
            </span>{" "}
            Đóng
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
export default DaoHo;
